import { totalOrBlank } from '@/features/publicsite/catalogCounts';
import type { CatalogCountsProps } from '@/features/publicsite/types/catalog/CatalogCountsProps';
import { publicHome } from '@/i18n/dictionaries/publicHome';
import { useTranslation } from '@/i18n/useTranslation';

/** The closing usage figures, printed from the same totals the hero and the grid read. */
export function HomeStats({ counts }: CatalogCountsProps) {
  const { t } = useTranslation(publicHome);
  const num = (n: number | undefined) => totalOrBlank(counts, n);

  return (
    <section className="section home-section--white">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{t('statsEyebrow')}</span>
            <h2>{t('statsHeading')}</h2>
            <p>{t('statsLead')}</p>
          </div>
        </div>
        <div className="section-body stat-grid">
          {(
            [
              ['advisors', 'statsAdvisors'],
              ['library', 'statsLibrary'],
              ['services', 'statsServices'],
              ['research', 'statsResearch'],
            ] as const
          ).map(([field, key]) => (
            <div className="stat-card" key={field}>
              <strong>{num(counts?.[field])}</strong>
              <span>{t(key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
